import { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';
import { postApi, getApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import Modal from 'react-modal';

function RateCal({ switchToBooking }) {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [getCountry, setGetCountry] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);

const handleOpenModal = (row) => {
  setSelectedRow(row);
  setModalIsOpen(true);
};

  const [formData, setFormData] = useState({
   
    ShipmentType: "Domestic",     // Dox | Non Dox | Rate Per Kg
    Weight: "",
    CountryName: "",
    PostalCode: "",
    invoice:"",
  });

  const handlePinCodeChange = async (e) => {
  const value = e.target.value.replace(/\D/g, "").slice(0, 6);

  setFormData((prev) => ({
    ...prev,
    PostalCode: value,
  }));

  // Fetch city when 6 digits entered
  if (value.length === 6) {
    try {
     const response = await getApi(`/Master/PincodeFinder?pincode=${value}`);
                     if (response.status === 1 && Array.isArray(response.data) && response.data.length > 0) {
                         const {  City_Name } = response.data[0];

        setFormData((prev) => ({
          ...prev,
          CountryName: City_Name,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          CountryName: "",
        }));
      }
    } catch (error) {
      console.log("Error fetching city:", error);
    }
  }
};

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  }
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  }
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  /* ================= COUNTRY LIST ================= */
 useEffect(() => {
         const fetchData = async (setData, Product_Type) => {
 
             try {
                 const response = await getApi(`/Master/GetInterDomestic?Product_Type=${Product_Type}`);
                 const data = response.Data || response.data
                 // Check if the response contains data, then update the corresponding state
                 if (data) {
                     setData(Array.isArray(data) ? data : []);
                 } else {
                     setData([]);
                 }
             } catch (err) {
                 console.error(`Error fetching data from /Master/GetInterDomestic:`, err);
 
             }
 
         };
         const Product_Type = formData.ShipmentType;
         fetchData(setGetCountry, Product_Type);
     }, [formData.ShipmentType])



  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.Weight || !formData.CountryName) {
      Swal.fire("Warning", "Weight and Country are required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {

        
        Weight: Number(formData.Weight),
        CountryName: formData.CountryName,
        PostalCode: formData.PostalCode?.trim() || null,
        InvoiceValue : formData.invoice,
      };

      const response = await postApi(
        "/Master/VendorRateSearchonWebsite",
        payload
      );

      if (response?.status === 1) {
       
        const temp = JSON.parse(localStorage.getItem("Login"));
        const data = temp?.UserType === "User" ? response.data.filter(f => f.Customer_Code === temp?.Customer_Code) : response.data;
        setData(data || []);
        setCurrentPage(1);
      } else {
        setData([]);
        Swal.fire("Info", response?.message || "No data found", "info");
      }
    } catch (err) {
      Swal.fire("Error", "Failed to fetch rate", "error");
    } finally {
      setLoading(false);
    }
  };

  /* ================= PAGINATION ================= */
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(data.length / rowsPerPage);

  /* ================= LOGO MAP ================= */
 
  /* ================= UI ================= */
  return (
    <div className="body">
      <div className="container1">

        {/* ================= FORM ================= */}
        <form onSubmit={handleSubmit} style={{ backgroundColor: "#f2f4f3" }}>
          <div className="fields2" style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>

            
 

            {/* Dox / Non Dox / Rate Per Kg */}
            <div className="input-field2">
              <label>Service Type</label>
              <select
                value={formData.ShipmentType}
                onChange={e =>
                  setFormData({ ...formData, ShipmentType: e.target.value })
                }
              >
                <option value="Domestic">Domestic</option>
                <option value="International">International</option>
               
              </select>
            </div>

            {/* Zip */}
            <div className="input-field2">
              <label>Zip Code</label>
              <input
                placeholder='Enter Zip Code'
                type="text"
                value={formData.PostalCode}
                onChange={handlePinCodeChange}
              />
            </div>

            {/* Country */}
            <div className="input-field3">
              <label>City / Country</label>
              <Select
                className="blue-selectbooking"
                classNamePrefix="blue-selectbooking"
                options={getCountry.map(c => ({
                  value: c.City_Name,
                  label: c.City_Name
                }))}
                value={
                  formData.CountryName
                    ? { value: formData.CountryName, label: formData.CountryName }
                    : null
                }
                onChange={(selected) =>
                  setFormData({ ...formData, CountryName: selected?.value || "" })
                }
                placeholder="Select Country"
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

           

             {/* Weight */}
            <div className="input-field2">
              <label>Weight</label>
              <input
                type="number"
                placeholder='Enter Weight'
                step="0.01"
                value={formData.Weight}
                onChange={e =>
                  setFormData({ ...formData, Weight: e.target.value })
                }
              />
            </div>


            <div className="input-field2">
              <label>Invoice Value</label>
              <input
                type="number"
                placeholder='Enter Invoice Value'
                step="0.01"
                value={formData.invoice}
                onChange={e =>
                  setFormData({ ...formData, invoice: e.target.value })
                }
              />
            </div>

            <div className="bottom-buttons" style={{ marginTop: "20px" }}>
              <button className="ok-btn" type="submit">Submit</button>
            </div>

          </div>
        </form>

        {/* ================= TABLE / LOADER ================= */}
        {loading ? (
          <div className="loader"></div>
        ) : (
          <div className='table-container'>
            <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Company Logo</th>
                  <th>Company Name</th>
                  <th>Customer Name</th>
                  <th>City / Country</th>
                  <th>Zone Name</th>
                  <th>Chargeable Wt</th>
                  <th>Rate Per Kg</th>
                  <th>Cost (₹)</th>
                  <th>Mode Type</th>
                </tr>
              </thead>
              <tbody>
                {currentRows.map((row, index) => (
                  <tr key={index} style={{ fontSize: "12px" }}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={row.Vendor_Img}
                        alt="Logo"
                        style={{ width: "80px", height: "40px" }}
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ fontSize: "14px", fontWeight: "bold", color: "#4FD1C5" }}

                        onClick={() => switchToBooking(row)}
                        
                      >
                        {row.Vendor_Name}
                        
                      </button>
                    </td>
                    <td>{row.Customer_Name}</td>
                    <td>{row.City_Name}</td>
                    <td>{row.Zone_Name}</td>
                    <td>{row.Input_Weight}</td>
                    <td>{row.Flag === "Fixed Rate" ? "-" : row.Rate_PerKg}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ fontSize: "14px", fontWeight: "bold", color: "#4FD1C5" }}

                        onClick={() => handleOpenModal(row)}
                        
                      >
                        ₹ {row.Grand_Total}
                        
                      </button>
                    </td>
                    <td>{row.Flag}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ================= PAGINATION ================= */}
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div className="pagination">
            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>{"<"}</button>
            <span style={{ color: "#333", padding: "5px" }}>
              Page {currentPage} of {totalPages}
            </span>
            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>{">"}</button>
          </div>
          <div className="rows-per-page" style={{ display: "flex", flexDirection: "row", color: "black", marginLeft: "10px" }}>
            <label style={{ marginTop: "16px", marginRight: "10px" }}>Rows per page:</label>
            <select style={{ height: "40px", width: "60px", marginTop: "10px" }} value={rowsPerPage} onChange={handleRowsPerPageChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
            </select>
          </div>

        </div >

      <Modal
  isOpen={modalIsOpen}
  className="custom-modal-volumetric"
  overlayClassName="custom-overlay"
  style={{
    overlay: {
      backgroundColor: "rgba(0,0,0,0.6)",
      zIndex: 9998,
    },
    content: {
      height: "90%",
      width:  "90%" ,
      maxWidth:"350px",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      margin: 0,
      padding: 0,
      overflowY: "auto",
      zIndex: 9999,
    },
  }}
>
  

<div
  className="custom-modal-content"
  
 
>
    <div className="header-tittle">
      <header>Charges Details</header>
    </div>

    <div className="container2">
      {selectedRow && (
        <table
          className="table table-bordered table-sm"
          style={{ whiteSpace: "nowrap"}}
        >
          <tbody>
  {[
    { label: "Basic Rate", value: selectedRow.Freight },
    { label: "Fov Charges", value: selectedRow.Fov_Charges },
    { label: "Docket Charges", value: selectedRow.Docket_Charges },
    { label: "Delivery Charges", value: selectedRow.Dilivery_Charges },
    { label: "Green Charges", value: selectedRow.Green_Charges },
    { label: "Oda Charges", value: selectedRow.Oda_Charges },
    { label: "Packing Charges", value: selectedRow.Packing_Charges },
    { label: "Hamali Charges", value: selectedRow.Hamali_Charges },
    { label: "Insurance Charges", value: selectedRow.Insurance_Charges },
    { label: "Clearance Charges", value: selectedRow.Clearance_Charges },
    { label: "Security Charges", value: selectedRow.Security_Charges },
    { label: "Transportation Charges", value: selectedRow.Transportation_Charges },
    { label: "DGR Charges", value: selectedRow.DGR_Charges },
    { label: "Risk Charges", value: selectedRow.Risk_Charges },
    { label: "ADC Charges", value: selectedRow.ADC_Charges },
    { label: "AWB Charges", value: selectedRow.AWB_Charges },
    { label: "Large Size Charges", value: selectedRow.LargeSize_Charges },
    { label: "Loading / Unloading", value: selectedRow.Loading_Unloading },
    { label: "Import Duty Charges", value: selectedRow.Import_Duty_Charges },
    { label: "Other Charges", value: selectedRow.Other_Charges },
    { label: "Fuel %", value: selectedRow.Fuel_Per },
    { label: "Fuel Charges", value: selectedRow.Fuel_Charges },
    { label: "Total Amount", value: selectedRow.Total_Amount },

    // Always show GST rows
    { label: "CGST", value: selectedRow.CGST},
    { label: "SGST", value: selectedRow.SGST},
    { label: "IGST", value: selectedRow.IGST},

    { label: "Grand Total", value: `₹ ${selectedRow.Grand_Total}`, alwaysShow: true },
  ]
    .filter((item) => item.alwaysShow || item.value > 0)
    .map((item, index) => (
      <tr key={index}>
        <td>{item.label}</td>
        <td>
          {item.label === "Grand Total" ? (
            <b>{item.value}</b>
          ) : (
            item.value
          )}
        </td>
      </tr>
    ))}
</tbody>
        </table>
      )}

      <div className="bottom-buttons">
        <button
          onClick={() => setModalIsOpen(false)}
          className="ok-btn"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</Modal>


      </div>
    </div>
  );
}

export default RateCal;